import type { BasketState } from '@front/common/src/ducks/customer/types';
import type { UniverseReference, User } from '@front/common/src/types/commons';
import { getCurrentCountry } from '@front/common/src/utils/country';
import { isCleaningReference, isWellnessReference } from '@front/common/src/utils/universes';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '../../constants/country-config';
import { hasMembership } from '../../utils/membership';

export type UseCanSubscribeToMembershipParams = {
  user?: User;
  mode?: BasketState['mode'];
  universeReference?: UniverseReference;
  isCleaningSpot?: boolean;
};

const useCanSubscribeToMembership = ({
  user,
  mode = 'creation',
  universeReference,
  isCleaningSpot,
}: UseCanSubscribeToMembershipParams) => {
  const isMembershipAvailable = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()].isAvailable;
  const shouldShowMembershipForWellness =
    isWellnessReference(universeReference) && isMembershipAvailable && mode === 'creation';
  const shouldShowMembershipForCleaning =
    isCleaningReference(universeReference) && isMembershipAvailable && isCleaningSpot && mode === 'creation';

  const shouldShowMembership = !!(shouldShowMembershipForWellness || shouldShowMembershipForCleaning);

  return user ? shouldShowMembership && !hasMembership(user) : shouldShowMembership;
};

export default useCanSubscribeToMembership;
